import React from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideWidgetClass('TextWidget', {
  attributes: {
    text: 'html',
  },
});

// `text` is rich HTML from the CMS editor and can itself contain <p> tags
// (multi-paragraph content) - wrapping it in another <p> (as the original
// Rails `scrivito_tag :p` did) is invalid HTML, since a <p> can't contain
// block content. Browsers silently auto-close the outer <p> at the first
// nested one when parsing, which is harmless for plain client rendering but
// broke SSR hydration (see api/prerender.mjs) once there was server-rendered
// markup to diff against: React saw a different DOM than the html string it
// was given. A <div> has no such restriction; the className keeps the 10px
// bottom margin every other paragraph on the page has, which the global
// `p {}` rule (main.scss) would otherwise have supplied.
const TextWidget = Scrivito.connect(({ widget }) => (
  <Scrivito.ContentTag tag="div" attribute="text" content={widget} className="tt-text-widget" />
));

Scrivito.provideComponent('TextWidget', TextWidget);

Scrivito.provideEditingConfig('TextWidget', {
  title: 'Text',
  properties: ['text'],
  attributes: {
    text: { title: 'Text' },
  },
});

export default TextWidget;
